module.exports = __webpack_public_path__ + "img/bookmaker.faedb2ae.svg";